import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  ShopProductDetailByIdGQL,
  ShopProductItemGQL,
  ShopProductListingGQL,
  ShopProductResolverDataGQL,
} from './gql/shop-product.gql.generated';
import { IShopCollection } from './types/shop-collection';
import {
  IShopProductDetail,
  IShopProductItem,
  IShopProductListingQuery,
  TShopProductDetailByIdQuery,
  TShopProductItemQuery,
  TShopProductResolverData,
  TShopProductResolverDataQuery,
} from './types/shop-product';

@Injectable()
export class ShopProductService {
  constructor(
    private readonly productDetailByIdGql: ShopProductDetailByIdGQL,
    private readonly productListingGql: ShopProductListingGQL,
    private readonly shopProductItemGQL: ShopProductItemGQL,
    private readonly shopProductResolverDataGQL: ShopProductResolverDataGQL,
  ) {}

  fetchProductDetail(query: TShopProductDetailByIdQuery): Observable<IShopProductDetail> {
    return this.productDetailByIdGql.fetch(query).pipe(map((r) => r.data.shopProduct));
  }

  fetchProductItem(query: TShopProductItemQuery): Observable<IShopProductItem> {
    return this.shopProductItemGQL.fetch(query).pipe(map((r) => r.data.shopProduct));
  }

  fetchProductListing(
    query: IShopProductListingQuery,
  ): Observable<IShopCollection<IShopProductItem>> {
    return this.productListingGql.fetch(query).pipe(
      map((r) => {
        const { items, totalItemsCount } = r.data;
        return {
          totalItemsCount,
          items,
        };
      }),
    );
  }

  fetchProductResolverData(
    query: TShopProductResolverDataQuery,
  ): Observable<TShopProductResolverData> {
    return this.shopProductResolverDataGQL.fetch(query).pipe(map((r) => r.data.shopProduct));
  }
}
